import React, { useState, useRef, useEffect } from "react";
import { Form, Container, Button, Row, Col, Card, Spinner } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { partidaApi } from "../../api/partidaApi";
import Swal from "sweetalert2";
import "../../../src/App.css";

const AdaugPartida = ({ tema }) => {
  const { user } = useAuth();
  const isAdmin = user?.rol === "administrator";
  const ref = useRef();
  const [fond, setFond] = useState("");
  const [sumal, setSumal] = useState("");
  const [ocol, setOcol] = useState("");
  const [up, setUp] = useState("");
  const [ua, setUa] = useState("");
  const [suprafata, setSuprafata] = useState("");
  const [natura, setNatura] = useState("");
  const [taiere, setTaiere] = useState("");
  const [volBrut, setVolBrut] = useState("");
  const [volBrutComercial, setVolBrutComercial] = useState("");
  const [volMedRas, setVolMedRas] = useState("");
  const [volMedDt, setVolMedDt] = useState("");
  const [volMedDm, setVolMedDm] = useState("");
  const [panta, setPanta] = useState("");
  const [distColectare, setDistColectare] = useState("");
  const [stoc, setStoc] = useState("nu");
  const [valTotal, setvalTotal] = useState("");
  const [termenIncI, setTermenIncI] = useState("");
  const [termenSfI, setTermenSfI] = useState("");
  const [termenIncII, setTermenIncII] = useState("");
  const [termenSfII, setTermenSfII] = useState("");
  const [termMax, setTermMax] = useState("");
  const [transport, setTransport] = useState("");
  const [nrProcedura, setNrProcedura] = useState("");
  const [seSalveaza, setSeSalveaza] = useState(false);
  

const optiuniLucrari = {
  "Principale codru": [
    "Rase pe parchete mici",
    "Rase in benzi",
    "Succesive in margine de masiv",
    "Succesive 1",
    "Succesive 2",
    "Succesive 3",
    "Succesive 4",
    "Succesive definitive",
    "Progresive in margine de masiv",
    "Progresive 1",
    "Progresive 2",
    "Progresive 3",
    "Progresive 4",
    "Progresive - Racordare",
    "Cvasigradinarite 1",
    "Cvasigradinarite 2",
    "Cvasigradinarite 3",
    "Cvasigradinarite 4",
    "Cvasigradinarite 5",
    "Cvasigradinarite 6",
    "Cvasigradinarite definitive",
    "Gradinarite",  
    "Transformare spre Gradinarit"
  ],
  "Principale crâng": [
    "Crang Simplu",
    "Crang - Cazanire",
    "Crang -Scaun"
  ],
  "Principale Substituiri": ["De refacere",
    "De substituire"
  ],
  "Tăieri de conservare": [
    "Tăieri de conservare"],

  "Doborârturi I":["Tăieri de accidentale"],
  "Secundare Rărituri": [
    "De îngrijire",
  ],
"Accidentale I":[
    "Tăieri de accidentale I",
  ],

"Accidentale II":[
    "Tăieri de accidentale II",
  ],
"Doborârturi II":["Tăieri de accidentale II"],
"Igienă":[
  "Igienizarea pădurii",
],
"Doborâturi în masă I":[
  "Doborâturi în masă I",
],
"Doborâturi în masă II":[
  "Doborâturi în masă II",
],

};

useEffect(() => {
  if (user) {

    if (user.rol !== "administrator" && user.ocol) {
      setOcol(user.ocol);
    }
  }
}, [user]);

  
  const valoareGarantie = valTotal  ? ( parseFloat(valTotal) * 0.01).toFixed(2) : "";
  const valTarifBrut = valTotal && volBrut ? (parseFloat(valTotal) / parseFloat(volBrut)).toFixed(2) : "";
  const valTarifBrutCom = valTotal && volBrutComercial ? (parseFloat(valTotal) / parseFloat(volBrutComercial)).toFixed(2) : "";  

  
  const tratezSubmit = async (evt) => {
    evt.preventDefault();
   const ocolFinal = user?.rol === "administrator" ? ocol : user?.ocol;

    const datePartida = {
      fond,
      sumal,
      up,
      ua,
      natura,
      taiere,
      stoc,
      transport,
      nrProcedura,
      ocol: ocolFinal,
      suprafata: parseFloat(suprafata) || 0,
      volBrut: parseFloat(volBrut) || 0,
      volBrutComercial: parseFloat(volBrutComercial) || 0,
      volMedRas: parseFloat(volMedRas) || 0,
      volMedDt: parseFloat(volMedDt) || 0,
      volMedDm: parseFloat(volMedDm) || 0,
      panta: parseFloat(panta) || 0,
      distColectare: parseFloat(distColectare) || 0,
      tarifBrut: parseFloat(valTarifBrut) || 0,
      tarifBrutCom: parseFloat(valTarifBrutCom) || 0,
      valTotal: parseFloat(valTotal) || 0,
      garantie: parseFloat(valoareGarantie) || 0,
      termenIncI,
      termenSfI,
      termenIncII,
      termenSfII,
      termMax: parseFloat(termMax) || 0,
      stare: "disponibil",
    };

  
    const campuriObligatorii = [
      "fond",
      "sumal",
      "ocol",
      "up",
      "ua",
      "natura",
      "volBrut",
      "valTotal",
    ];
    const lipsescDate = campuriObligatorii.some((key) => !datePartida[key]);

    if (lipsescDate) {
      Swal.fire({
        icon: "warning",
        title: "Atenție!",
        text: "Te rugăm să completezi toate câmpurile obligatorii!",
        confirmButtonColor: "#3085d6",
      });
      return;
    }
    setSeSalveaza(true);
    try {
      if (!partidaApi) {
        throw new Error("Serviciul API nu a fost încărcat corect.");
      }

      const result = await partidaApi.add(datePartida, user);

      await Swal.fire({
        icon: "success",
        title: "Succes!",
        text: result.message || "Partida a fost salvată cu succes.",
        timer: 3000,
        showConfirmButton: true,
        confirmButtonColor: "#28a745",
      });

           resetareFormular();
    } catch (error) {
      console.error("Eroare la salvare:", error);

      Swal.fire({
        icon: "error",
        title: "Eroare la salvare",
        text:
          error.message || "A apărut o problemă la comunicarea cu serverul.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setSeSalveaza(false);
    }
  };

  const resetareFormular = () => {
    const setters = [
      setFond,
      setSumal,
      setUp,
      setUa,
      setSuprafata,
      setNatura,
      setTaiere,
      setVolBrut,
      setVolBrutComercial,
      setVolMedRas,
      setVolMedDt,
      setVolMedDm,
      setPanta,
      setvalTotal,
      setTermenIncI,
      setTermenSfI,
      setTermenIncII,
      setTermenSfII,
      setTermMax,
      setTransport,
      setNrProcedura,
    ];


    setters.forEach((s) => s(""));
    setDistColectare("");
    setStoc("nu");

    if (isAdmin) setOcol("");

    if (ref.current) ref.current.value = "";
  };

 


  const verificareNumerePozitive = (setValue) => (e) => {
    const val = e.target.value;
    if (val === "" || parseFloat(val) >= 0) {
      setValue(val);
    }
  };

  const isDark = tema === "dark";
  const cardClass = isDark
    ? "bg-dark text-white border-secondary mb-4 shadow-sm"
    : "bg-white text-dark border-light mb-4 shadow-sm";
  const inputClass = isDark
    ? "bg-secondary text-white border-dark"
    : "bg-light text-dark border-muted";

  return (
    <Container className="py-4 px-3" style={{ maxWidth: "1200px" }}>
      <Form onSubmit={tratezSubmit}>
        {/* SECȚIUNEA 1: DATE GENERALE */}

        <Card className={cardClass}>
          <Card.Header className="fw-bold text-info small bg-transparent border-0 pt-3 px-4">
            <div className="d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom border-opacity-10 border-secondary">
              <div>
                <h2 className="h4 fw-bold mb-0 tracking-tight text-success">
                  Adaugă Partidă
                </h2>
              </div>
            </div>
            [1] Identificare și Localizare Parchet
          </Card.Header>
          <Card.Body className="px-4 pb-4">
            <Row>
              <Col md={2} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Nr. Procedură
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={nrProcedura}
                    onChange={(e) => setNrProcedura(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={3} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Ocol Silvic *
                  </Form.Label>
                  <Form.Select
                    value={ocol}
                    onChange={(e) => setOcol(e.target.value)}
                    disabled={!isAdmin}
                    className={inputClass}
                  >
                    <option value="">Alege Ocolul...</option>
                    {[
                      "Ludus",
                      "Targu Mures",
                      "Reghin",
                      "Gurghiu",
                      "Fancel",
                      "Rastolita",
                      "Lunca Bradului",
                      "Sovata",
                      "Tarnaveni",
                      "Sighisoara",
                    ].map((o) => (
                      <option key={o} value={o}>
                        {o}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={2} sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Nr. Fond *
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={fond}
                    onChange={(e) => setFond(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Nr. SUMAL *
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={sumal}
                    onChange={(e) => setSumal(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={1} sm={2}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">UP *</Form.Label>
                  <Form.Control
                    type="text"
                    value={up}
                    onChange={(e) => setUp(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={1} sm={2}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">UA *</Form.Label>
                  <Form.Control
                    type="text"
                    value={ua}
                    onChange={(e) => setUa(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={1} sm={2}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-muted">
                    Stoc *
                  </Form.Label>
                  <Form.Select
                    value={stoc}
                    onChange={(e) => setStoc(e.target.value)}
                    className={inputClass}
                  >
                    <option value="da">Da</option>
                    <option value="nu">Nu</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Natura Produs *
                  </Form.Label>
                  <Form.Select
                    value={natura}
                    onChange={(e) => {
                      setNatura(e.target.value);
                      setTaiere("");
                    }}
                    className={inputClass}
                  >
                    <option value="">Alege categoria...</option>
                    {Object.keys(optiuniLucrari).map((cat) => (
                      <option key={cat} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Natura Tăierii
                  </Form.Label>
                  <Form.Select
                    value={taiere}
                    disabled={!natura}
                    onChange={(e) => setTaiere(e.target.value)}
                    className={inputClass}
                  >
                    <option value="">Alege natura lucrării...</option>
                    {natura &&
                      optiuniLucrari[natura].map((sub) => (
                        <option key={sub} value={sub}>
                          {sub}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={2} sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Suprafață (ha)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={suprafata}
                    onChange={verificareNumerePozitive(setSuprafata)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Pantă (%)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    step="0.1"
                    value={panta}
                    onChange={verificareNumerePozitive(setPanta)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Dist. Colectare
                  </Form.Label>
                  <Form.Select
                    value={distColectare}
                    onChange={(e) => setDistColectare(e.target.value)}
                    className={inputClass}
                  >
                    <option value="">Alege...</option>
                    <option value="0-250">0-250 m</option>
                    <option value="251-500">251-500 m</option>
                    <option value="501-1000">501-1000 m</option>
                    <option value="1001-1500">1001-1500 m</option>
                    <option value="> 1500">&gt; 1500 m</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* SECȚIUNEA 2: DATE TEHNICE ȘI COMPONENTĂ MASĂ LEMNOASĂ */}
        <Card className={cardClass}>
          <Card.Header className="fw-bold text-uppercase text-info small bg-transparent border-0 pt-3 px-4">
            [2] Volum
          </Card.Header>
          <Card.Body className="px-4 pb-4">
            <Row>
              <Col md={3} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Volum Brut Tot. (mc) *
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={volBrut}
                    onChange={verificareNumerePozitive(setVolBrut)}
                    className={inputClass}
                    style={{ fontWeight: "600" }}
                  />
                </Form.Group>
              </Col>
              <Col md={3} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Vol. Brut Comerciabil (mc)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={volBrutComercial}
                    onChange={verificareNumerePozitive(setVolBrutComercial)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Med. Rășinoase
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={volMedRas}
                    onChange={verificareNumerePozitive(setVolMedRas)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Med. Foioase Tari
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={volMedDt}
                    onChange={verificareNumerePozitive(setVolMedDt)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Med. Foioase Moi
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={volMedDm}
                    onChange={verificareNumerePozitive(setVolMedDm)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* SECȚIUNEA 3: VALORI FINANCIARE (DEZACTIVATE - CALCULATE AUTOMAT) */}
        <Card
          className={cardClass}
          style={{
            background: isDark
              ? "rgba(30, 41, 59, 0.2)"
              : "rgba(241, 245, 249, 0.5)",
          }}
        >
          <Card.Header className="fw-bold text-uppercase text-info small bg-transparent border-0 pt-3 px-4">
            [3] Indicatori financiari
          </Card.Header>
          <Card.Body className="px-4 pb-4">
            <Row>
              <Col md={3} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-dark-emphasis fw-bold">
                    Valoare Totală Estimata (RON) *
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={valTotal}
                    onChange={verificareNumerePozitive(setvalTotal)}
                    className="border-success"
                    style={{ fontSize: "1.1rem", fontWeight: "700" }}
                  />
                </Form.Group>
              </Col>
              <Col md={3} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold">
                    Tarif Brut (RON/mc)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={valTarifBrut}
                    className="form-control-calcule"
                  />
                </Form.Group>
              </Col>
              <Col md={3} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Tarif Brut Comerciabil
                  </Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={valTarifBrutCom}
                    className="form-control-calcule"
                  />
                </Form.Group>
              </Col>
              <Col md={3} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Garanție Contractuală (1%)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={valoareGarantie}
                    className="form-control-calcule text-success fw-bold"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* SECȚIUNEA 4: TERMENE EXECUȚIE ȘI LOGISTICĂ */}
        <Card className={cardClass}>
          <Card.Header className="fw-bold text-uppercase text-info small bg-transparent border-0 pt-3 px-4">
            [4] Regim Exploatare
          </Card.Header>
          <Card.Body className="px-4 pb-4">
            <Row>
              <Col md={2} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Început Perioada I
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={termenIncI}
                    onChange={(e) => setTermenIncI(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Sfârșit Perioada I
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={termenSfI}
                    min={termenIncI}
                    onChange={(e) => setTermenSfI(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Început Perioada II
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={termenIncII}
                    min={termenSfI}
                    onChange={(e) => setTermenIncII(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Sfârșit Perioada II
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={termenSfII}
                    min={termenIncII}
                    onChange={(e) => setTermenSfII(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Termen Max (O.M. 1540)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={termMax}
                    onChange={(e) => setTermMax(e.target.value)}
                    className={inputClass}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold ">
                    Transport
                  </Form.Label>
                  <Form.Select
                    value={transport}
                    onChange={(e) => setTransport(e.target.value)}
                    className={inputClass}
                  >
                    <option value="">Alege tipul...</option>
                    <option value="cuTransport">Cu transport</option>
                    <option value="faraTransport">Fără transport</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <div className="mt-4 mb-5">
          <Button
            variant="success"
            type="submit"
            disabled={seSalveaza}
            className="w-100 py-3 fw-bold uppercase btn-submit-premium text-uppercase shadow rounded-3"
          >
            {seSalveaza ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Se salvează partida...
              </>
            ) : (
              "Salvează Partida"
            )}
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default AdaugPartida;
